import { useEffect, useState } from "react";
import { Tag, X, Plus } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";

export const tagColor = (t) => {
  const palette = ["bg-amber-500/15 text-amber-300 border-amber-500/30", "bg-sky-500/15 text-sky-300 border-sky-500/30", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30", "bg-rose-500/15 text-rose-300 border-rose-500/30", "bg-violet-500/15 text-violet-300 border-violet-500/30"];
  let h = 0;
  for (const ch of t.toLowerCase()) h = (h * 31 + ch.charCodeAt(0)) % 997;
  return palette[h % palette.length];
};

export const CustomerTags = ({ customerId, tags, onChange }) => {
  const [all, setAll] = useState([]);
  const [val, setVal] = useState("");
  useEffect(() => { api.customerTags().then(setAll).catch(() => {}); }, [customerId]);
  const save = async (next) => {
    try {
      const r = await api.setCustomerTags(customerId, next);
      onChange(r.tags);
      setAll((a) => [...new Set([...a, ...r.tags])].sort((x, y) => x.toLowerCase().localeCompare(y.toLowerCase())));
    } catch { toast.error("Errore nel salvataggio etichette"); }
  };
  const add = (t) => { t = t.trim(); if (t && !tags.includes(t)) save([...tags, t]); setVal(""); };
  const suggestions = all.filter((t) => !tags.includes(t) && (!val || t.toLowerCase().includes(val.toLowerCase()))).slice(0, 6);
  return (
    <div data-testid="customer-tags">
      <h3 className="text-sm font-semibold mb-2 flex items-center gap-2"><Tag className="h-4 w-4 text-sky-400" /> Etichette</h3>
      <div className="flex flex-wrap gap-1.5 mb-2">
        {tags.length === 0 && <span className="text-xs text-muted-foreground">Nessuna etichetta</span>}
        {tags.map((t) => (
          <Badge key={t} className={`border gap-1 ${tagColor(t)}`} data-testid={`customer-tag-${t}`}>{t}<button onClick={() => save(tags.filter((x) => x !== t))} data-testid={`customer-tag-remove-${t}`} className="hover:opacity-70"><X className="h-3 w-3" /></button></Badge>
        ))}
      </div>
      <div className="flex gap-2">
        <Input data-testid="customer-tag-input" value={val} onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add(val)} placeholder="Nuova etichetta (es. VIP)" className="h-9 bg-card border-border" />
        <Button size="sm" variant="secondary" onClick={() => add(val)} disabled={!val.trim()} data-testid="customer-tag-add"><Plus className="h-4 w-4" /></Button>
      </div>
      {suggestions.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-2">
          {suggestions.map((t) => <button key={t} onClick={() => add(t)} data-testid={`customer-tag-suggest-${t}`} className="text-xs rounded-full border border-border px-2 py-0.5 hover:bg-muted">{t}</button>)}
        </div>
      )}
    </div>
  );
};
